import { Address } from 'api/fulfillment/utils';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { fulfillmentApiService } from 'api/fulfillment/fulfillment-api.service';

export const fetchSuggestedAddresses = createAsyncThunk(
  'order/fetch/address-validation',
  (address: Address) => fulfillmentApiService.validateAddress(address),
);
